
export enum DataKeyDefine {
    TEST = "TEST",

    LastLoginType = "LastLoginType",
    GoogleIdToken = "GoogleIdToken",
    SubgameListCache = "SubgameListCache",
    PlayedGameIds = "PlayedGameIds",
    BankInfos = "BankInfosV2",
    RechargePhone = "RechargePhone",
    BankAccNameInfo = "BankAccNameInfo",
    UUID = "UUID",
    Share = "Share",
}
